<template>
  <div class="login-wrap">
    <div class="top">手机快捷登录</div>
    <div class="content">
      <div class="title">手机号码</div>
      <div class="fieldBox">
        <div>
          <van-field
            v-model="phone"
            maxlength="11"
            placeholder="请输入您的手机号码"
            type="digit"
          />
        </div>
        <div
          v-if="phone"
          @click="deletePhone"
        >
          <img
            class="delete"
            src="@/assets/img/car-life/ic_delete_code.png"
          >
        </div>
      </div>

      <div
        class="title"
        style="margin-top: 24px"
      >验证码</div>
      <div class="fieldBox">
        <div class="field-wrapper">
          <van-field
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
            type="digit"
          />
        </div>
        <div
          class="code"
          :class="{ disable: codeDisable }"
          @click="sendCodeClick"
        >
          {{ codeTitle }}
        </div>
      </div>
      <van-button
        class="submit"
        :disabled="isDisabled"
        type="info"
        @click="submitClick"
      >提交</van-button>
    </div>
    <van-dialog
      v-model="show"
      title="切换企业"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="modalCenter">
        <van-button
          type="info"
          plain
          size="large"
          v-for="(item, index) in companyList"
          :key="index"
          @click="checkCompany(item)"
          class="item"
        >
          {{ item.companyName }}
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getCode, codeLogin, vasCommonCheckToken, carList, getCodePc, employeeCompany, login, switchCompany } from '@/common/api.js';
import { cookieSet, cookieRemove } from '@/common/cookie';
import { MobileRegExp } from '@/common/regex.js';

// 限制字符输入规则
import { mixins } from '@/mixins/replaceInput';
import { debounce } from 'lodash';

export default {
  mixins: [mixins],
  data() {
    return {
      phone: '',
      code: '',
      timer: null,
      codeTitle: '获取验证码',
      codeDisable: false,
      show: false,
      companyList: [],
      loginInfo: {}
    };
  },
  computed: {
    isDisabled() {
      if (this.code && this.code.length > 0 && this.phone && this.phone.length > 0) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      }
    },
    countDown() {
      this.countDownSecond--;
      if (this.countDownSecond < 0) {
        clearInterval(this.timer);
        this.codeTitle = '获取验证码';
        this.codeDisable = false;
        return;
      }
      this.codeTitle = '获取验证码' + this.countDownSecond + 's';
    },
    sendCodeClick: debounce(
      async function() {
        // 验证码不可点击
        if (this.codeDisable) {
          return;
        }
        if (!this.phone) {
          Toast('手机号不能为空');
          return;
        }
        if (this.phone.length != 11 || !MobileRegExp.test(this.phone)) {
          Toast('请输入正确的手机号');
          return;
        }
        try {
          const res = await getCodePc({ phone: this.phone });
          this.codeDisable = true;
          Toast('获取验证码成功');
          this.countDownSecond = 60;
          this.timer = setInterval(this.countDown, 1000);
        } catch (error) {}
      },
      3000,
      { leading: true, trailing: false }
    ),
    deletePhone() {
      this.phone = '';
    },
    deleteCode() {
      this.code = '';
    },
    submitClick: debounce(
      async function() {
        if (this.phone.length !== 11 || !MobileRegExp.test(this.phone)) {
          Toast('请输入正确的手机号');
          return;
        }
        try {
          const res = await login({ phone: this.phone, code: this.code });
          // if (
          //   document.domain.indexOf('vas') > -1 ||
          //   document.domain.indexOf('zengzhi') > -1
          // ) {
          //   cookieSet('token', res);
          //   cookieSet('phone', this.phone);
          // }
          // localStorage.setItem('_phone', this.phone);
          // this.$router.push({
          //   path: '/accidentRescue/list',
          //   query: {
          //     phone: this.phone
          //   }
          // });
          if (res) {
            this.loginInfo = res;
            cookieSet('token', this.loginInfo.token);
            this.getEmployeeCompany();
          }
        } catch (error) {

        }
      },
      3000,
      { leading: true, trailing: false }
    ),
    async getEmployeeCompany() {
      try {
        const res = await employeeCompany({ isWxDps: '1' });
        if (res) {
          this.companyList = res;
          this.show = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkCompany(data) {
      cookieSet('channelCompanyCode', data.id);
      try {
        const res = await switchCompany({ companyId: data.id });
        this.$router.push({
          path: '/accidentRescue/list',
          query: {
            phone: this.phone
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  },

  destroyed() {
    try {
      if (this.timer) {
        clearInterval(this.timer);
      }
    } catch (error) {}
  }
};
</script>

<style lang="scss">
.login-wrap {
  .van-cell {
    padding-left: 0px;
  }
}
</style>

<style lang="scss" scoped>
.login-wrap {
  width: 7.5rem;
  height: 100wh;
  background-color: white;
}

.top {
  font-size: 0.48rem;
  color: #383838;
  margin-left: 0.6rem;
  margin-top: 0.96rem;
}

.content {
  margin-left: 0.6rem;
  width: 6.3rem;
  margin-top: 1.12rem;
  display: flex;
  font-size: 0.32rem;
  flex-direction: column;
}

.fieldBox {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.32rem;
  color: #383838;
  flex: 1;

  .delete {
    height: 0.4rem;
    width: 0.4rem;
  }

  .field-wrapper {
    flex: 1;
  }

  .code {
    color: #3399ff;

    &.disable {
      color: #b3d9ff;
    }
  }
}

.title {
  color: #646464;
  font-size: 0.3rem;
  margin-bottom: 0.32rem;
}

.submit {
  margin-top: 1.45rem;
  width: 6.3rem;
  height: 0.96rem;
  font-size: 0.32rem;
}
.modalCenter{
  margin: 0.3rem 0;
  padding: 0 0.2rem;
  box-sizing: border-box;
  max-height: 70vh;
  overflow: auto;
  .item{
    text-align: center;
    margin-top: 0.3rem;
  }
}
</style>
